//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionBuilder.js";
import "../Motion/Motion.SelectLink.js";
import "../no/Expression.js";
import "../Motion/Motion.CustomizedMaterialBuilder.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"ActionLink",0,"Motion.SelectLink",0],[0,"ActionLinkOvrCtrl",1,0],[0,"ActionPoint",1,"Point",0],[0,"ActionPointOvrCtrl",1,0],[1,"Area",0,"Expression",0],[1,"AsyTimoshenkoCorrection",0,"Expression",0],[1,"AszTimoshenkoCorrection",0,"Expression",0],[1,"BaseLink",0,"Motion.SelectLink",0],[0,"BaseLinkOvrCtrl",1,0],[0,"BasePoint",1,"Point",0],[0,"BasePointOvrCtrl",1,0],[1,"CustomizedMaterial",0,"Motion.CustomizedMaterialBuilder",0],[1,"DampingRatio",0,"Expression",0],[0,"DampingType",1,0],[0,"Direction",1,"Direction",0],[0,"DirectionOvrCtrl",1,0],[1,"FreeLength",0,"Expression",0],[1,"InertiaIyy",0,"Expression",0],[1,"InertiaIzz",0,"Expression",0],[1,"InertiaK",0,"Expression",0],[0,"IsBeamCrossDamping",1,0],[0,"Name",1,0],[0,"VectorType",1,0],[0,"VectorTypeOvrCtrl",1,0]],[],[]];
SPLM.Motion.BeamForceBuilder = class extends SPLM.Motion.MotionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.BeamForceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.BeamForceBuilder.VectorTypes = Object.freeze({
    "Y" : "Y", "Z" : "Z"});

SPLM.Motion.BeamForceBuilder.DampingTypes = Object.freeze({
    "Viscous" : "Viscous", "Structural" : "Structural"});

export default SPLM;